import { get } from '../request';
import { APP_CONFIG } from '@/config';
import type { SuchenPlusStatus } from '@/@types/suchenPlus';

export const getSuchenPlusStatus = async (): Promise<SuchenPlusStatus> =>
  await get<SuchenPlusStatus>(`${APP_CONFIG.entitlementApiUrl}/v1/suchen-plus/my`);
